import { createFileRoute } from '@tanstack/react-router'
import { LiquidityRecord } from '@/features/trade/pool/LiquidityRecord'

export const Route = createFileRoute('/_app/pool/logs')({
  component: LiquidityRecord,
})
